import apiClient from '@/api/apiClient'
import imagenDefault from '@/assets/sin-imagen.png'

export default {
  name: 'DashboardAlmacen',

  data() {
    return {
      cargando: false,
      pendientes: [],
      concluidos: [],
      totales: {
        Total: 0,
        Pendientes: 0,
        EnProceso: 0,
        Concluidos: 0,
        TotalCargadoConcluidos: 0
      },
      mensajeError: '',
      intervaloDashboard: null,
      tabActiva: 0,
      dialogoImagen: false,
      dialogoFoto: '',
      dialogoTitulo: '',
      imagenDefault,
      mostrarDebug: false
    }
  },

  computed: {
    sinIniciar() {
      return this.pendientes.filter(item => {
        const estatus = String(item.EstatusCarga || '').toUpperCase().trim()
        return estatus === 'SIN INICIAR' || estatus === 'PENDIENTE' || estatus === 'PENDIENTES'
      })
    },

    enProceso() {
      return this.pendientes.filter(item => {
        const estatus = String(item.EstatusCarga || '').toUpperCase().trim()
        return estatus === 'EN PROCESO'
      })
    },

    itemsTotales() {
      return [...this.pendientes, ...this.concluidos]
    },

    itemsMostrar() {
      if (this.tabActiva === 0) return this.itemsTotales
      if (this.tabActiva === 1) return this.sinIniciar
      if (this.tabActiva === 2) return this.enProceso
      return this.concluidos
    },

    nombreTabActual() {
      if (this.tabActiva === 0) return 'Total'
      if (this.tabActiva === 1) return 'Pendientes'
      if (this.tabActiva === 2) return 'En proceso'
      return 'Concluidos'
    }
  },

  mounted() {
    this.obtenerDashboard(true)

    this.intervaloDashboard = setInterval(() => {
      this.obtenerDashboard(false)
    }, 30000)
  },

  beforeDestroy() {
    if (this.intervaloDashboard) {
      clearInterval(this.intervaloDashboard)
      this.intervaloDashboard = null
    }
  },

  methods: {
    normalizarItem(item = {}) {
      return {
        ...item,
        ID: item.ID || 0,
        Anden: item.Anden || 'N/D',
        NombreCamion: item.NombreCamion || 'N/D',
        NombreChofer: item.NombreChofer || 'N/D',
        Referencia: item.Referencia || 'SIN REFERENCIA',
        TotalArticulos: Number(item.TotalArticulos || 0),
        Cargados: Number(item.Cargados || 0),
        Restantes: Number(item.Restantes || 0),
        Porcentaje: Number(item.Porcentaje || 0),
        TiempoTexto: item.TiempoTexto || '0 min',
        EstatusCarga: item.EstatusCarga || 'SIN INICIAR',
        PesoVehiculo: item.PesoVehiculo || '0.00 ton',
        PesoCarga: item.PesoCarga || '0.00 ton',
        LlenadoVehiculo: item.LlenadoVehiculo || '0.00%',
        LlenadoVehiculoValor: Number(item.LlenadoVehiculoValor || 0),
        PesoVehiculoValor: Number(item.PesoVehiculoValor || 0),
        PesoCargaValor: Number(item.PesoCargaValor || 0),
        DiferenciaPeso: item.DiferenciaPeso || '0.00 ton',
        DiferenciaPesoValor: Number(item.DiferenciaPesoValor || 0),
        EstatusPeso: item.EstatusPeso || 'JUSTO',
        ImagenSupervisoras: Array.isArray(item.ImagenSupervisoras)
          ? item.ImagenSupervisoras
          : [],
        ImagenChofer: item.ImagenChofer || this.imagenDefault,
        ImagenCamion: item.ImagenCamion || this.imagenDefault
      }
    },

    async obtenerDashboard(mostrarLoader = false) {
      if (mostrarLoader) {
        this.cargando = true
      }

      this.mensajeError = ''

      try {
        const usuarioClave = localStorage.getItem('usuarioClave')
        const usuarioRaw = localStorage.getItem('usuario')
        const usuarioObj = JSON.parse(usuarioRaw || '{}')
        const agente = usuarioClave || usuarioObj.usuario || ''

        const response = await apiClient.post('Almacen/getDashboardCarga', {
          Agente: agente
        })

        const data = response.data.data || response.data

        if (data.error) {
          this.mensajeError =
            data.msg || 'Ocurrió un error al consultar el dashboard.'
          return
        }

        this.pendientes = (data.pendientes || []).map(item =>
          this.normalizarItem(item)
        )

        this.concluidos = (data.concluidos || []).map(item =>
          this.normalizarItem(item)
        )

        const sinIniciarCount = this.pendientes.filter(item => {
          const estatus = String(item.EstatusCarga || '').toUpperCase().trim()
          return (
            estatus === 'SIN INICIAR' ||
            estatus === 'PENDIENTE' ||
            estatus === 'PENDIENTES'
          )
        }).length

        const enProcesoCount = this.pendientes.filter(item => {
          const estatus = String(item.EstatusCarga || '').toUpperCase().trim()
          return estatus === 'EN PROCESO'
        }).length

        this.totales = {
          Total: this.pendientes.length + this.concluidos.length,
          Pendientes: sinIniciarCount,
          EnProceso: enProcesoCount,
          Concluidos: this.concluidos.length,
          TotalCargadoConcluidos:
            data.totales?.TotalCargadoConcluidos || 0
        }
      } catch (error) {
        this.mensajeError =
          error.response?.data?.msg ||
          error.response?.data?.message ||
          'No se pudo conectar con el servidor.'
      } finally {
        this.cargando = false
      }
    },

    isPendienteBloqueado(item) {
      const estatus = String(item.EstatusCarga || '').toUpperCase().trim()
      return estatus === 'SIN INICIAR' || estatus === 'PENDIENTE' || estatus === 'PENDIENTES'
    },

    getColor(item) {
      const estatus = String(item.EstatusCarga || '').toUpperCase().trim()
      if (estatus === 'COMPLETO') return 'green'
      if (estatus === 'EN PROCESO') return 'yellow darken-2'
      return 'red'
    },

    getFillColor(item) {
      const estatus = String(item.EstatusCarga || '').toUpperCase().trim()
      if (estatus === 'COMPLETO') return '#43a047'
      if (estatus === 'EN PROCESO') return '#fdd835'
      return '#e53935'
    },

    getStatusTextClass(item) {
      const estatus = String(item.EstatusCarga || '').toUpperCase().trim()
      if (estatus === 'COMPLETO') return 'status-complete-text'
      if (estatus === 'EN PROCESO') return 'status-process-text'
      return 'status-pending-text'
    },

    getPesoStatusClass(item) {
      const estatus = String(item.EstatusPeso || '').toUpperCase().trim()
      if (estatus === 'JUSTO') return 'status-complete-text'
      if (estatus === 'REBASÓ') return 'status-pending-text'
      return 'status-process-text'
    },

    abrirDialogoImagen(foto, titulo) {
      this.dialogoFoto = foto && String(foto).trim() ? foto : this.imagenDefault
      this.dialogoTitulo = titulo || 'Imagen'
      this.dialogoImagen = true
    },

    onImageError(event) {
      event.target.src = this.imagenDefault
    },

    onAvatarError(event) {
      event.target.src = this.imagenDefault
    },

    getSupervisorNames(item) {
      if (!item.Supervisoras || !String(item.Supervisoras).trim()) return []

      return String(item.Supervisoras)
        .split(',')
        .map(nombre => nombre.trim())
        .filter(Boolean)
    },

    getSupervisorKeys(item) {
      if (!item.ClavesSupervisoras || !String(item.ClavesSupervisoras).trim()) return []

      return String(item.ClavesSupervisoras)
        .split(',')
        .map(clave => clave.trim())
        .filter(Boolean)
    },

    getSupervisorImageByClave(clave) {
      if (!clave) return this.imagenDefault
      return `${process.env.VUE_APP_API_URL}supervisoras/${clave}.jpg`
    },

    getSupervisorImages(item) {
      const nombres = this.getSupervisorNames(item)

      if (
        Array.isArray(item.ImagenSupervisoras) &&
        item.ImagenSupervisoras.length > 0
      ) {
        return item.ImagenSupervisoras.slice(0, 2).map((sup, index) => ({
          clave: sup.clave || '',
          nombre: nombres[index] || `Supervisora ${index + 1}`,
          foto: sup.imagen || this.imagenDefault
        }))
      }

      const claves = this.getSupervisorKeys(item)

      return claves.slice(0, 2).map((clave, index) => ({
        clave,
        nombre: nombres[index] || `Supervisora ${index + 1}`,
        foto: this.getSupervisorImageByClave(clave)
      }))
    },

    abrirImagenSupervisor(supervisora) {
      this.abrirDialogoImagen(
        supervisora.foto,
        supervisora.nombre || supervisora.clave || 'Supervisora'
      )
    },

    abrirImagenVehiculo(item) {
      this.abrirDialogoImagen(
        item.ImagenCamion || this.imagenDefault,
        item.NombreCamion || 'Vehículo'
      )
    },

    abrirImagenChofer(item) {
      this.abrirDialogoImagen(
        item.ImagenChofer || this.imagenDefault,
        item.NombreChofer || 'Chofer'
      )
    },

    formatFechaHora(valor) {
      if (!valor) return 'N/D'

      const fecha = new Date(valor)
      if (Number.isNaN(fecha.getTime())) return valor

      return fecha.toLocaleString('es-MX', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    }
  }
}